import {countToRate} from "../../../logic/combined-metrics-logic";
import {MetricArrays, MetricSingleValues} from "../../CombinedMetricsTable";

export interface IMetricIssue {
    issueType: "negativeMoveIns";
    monthIndex: number;
    unitTypeName: string;
    unitTypeCount: number;
    counts: MetricArrays;
    rates: MetricArrays;
    previousVersionLastMonthData: MetricSingleValues;
}

export interface IMetricSolverReturn {
    occupancySuggestion: number | null,
    renewalSuggestion: number | null,
}

// If a suggestion comes back as null, then treat it as impossible to fix via that metric - should realistically only be renewals
export function solveMoveIns(
    expirationCount: number,
    renewalCount: number,
    occupancyCount: number,
    previousOccupancyCount: number,
    unitCount: number,
): IMetricSolverReturn {
    const res: IMetricSolverReturn = {
        occupancySuggestion: null,
        renewalSuggestion: null,
    }
    const moveOutCount = expirationCount - renewalCount;
    const occupancyCountNeeded = previousOccupancyCount - moveOutCount;
    const renewalCountNeeded = occupancyCount - (previousOccupancyCount - expirationCount);
    if (renewalCountNeeded >= 0) {
        res.renewalSuggestion = countToRate(renewalCountNeeded, expirationCount);    
    }
    if (unitCount > 0) {
        res.occupancySuggestion = countToRate(occupancyCountNeeded, unitCount);
    }
    if (res.occupancySuggestion !== null && res.occupancySuggestion > 100) {
        res.occupancySuggestion = 100;
    }
    return res;
}
